import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AwsRulesService } from 'src/services/aws-rules.service';
import { ConfiguracaoGeralService } from 'src/services/configuracao-geral.service';
import { PermissoesService } from 'src/services/permissoes.service';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'app-evento-servico',
    templateUrl: './evento-servico.component.html',
    styleUrls: ['./evento-servico.component.scss'],
    standalone: false
})
export class EventoServicoComponent implements OnInit, AfterViewInit {
  data: any[] = []
  displayModal: boolean = false
  loading: boolean = false
  cron: boolean = false
  form: FormGroup;
  direitoInserir: boolean = false;
  direitoEditar: boolean = false;
  configuracaoGeralId: number | null = null;
  eventoNivelOscilanteDesativado: boolean = false;
  loadingConfiguracaoGeral: boolean = false;
  salvandoConfiguracaoGeral: boolean = false;
  private revertendoCheckbox = false;
  @ViewChild('tableWrapper', { static: false }) tableWrapper: ElementRef;
  scrollHeight: string = '600px';
  constructor(
    protected _formBuilder: FormBuilder,
    protected permissaoService: PermissoesService,
    protected _awsRulesService: AwsRulesService,
    protected _configuracaoGeralService: ConfiguracaoGeralService,
    private messageService: MessageService,
  ) { }
  ngOnInit(): void {
    this.direitoInserir = this.permissaoService.can('config_evento_servico_inserir');
    this.direitoEditar = this.permissaoService.can('config_evento_servico_editar');

    this.form = this._formBuilder.group({
      id: [null],
      rule_name: [null],
      schedule_expression: [null],
      schedule_expression_cron: [null],
      rule_description: [null],
    })
    this.index()
    this.carregarConfiguracaoGeral()
  }

  carregarConfiguracaoGeral(): void {
    this.loadingConfiguracaoGeral = true;
    this._configuracaoGeralService.atual().subscribe({
      next: (json) => {
        this.configuracaoGeralId = json?.id ?? null;
        this.eventoNivelOscilanteDesativado = !!json?.evento_niveloscilante;
        this.loadingConfiguracaoGeral = false;
      },
      error: () => {
        this.loadingConfiguracaoGeral = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Não foi possível carregar a configuração geral.',
        });
      },
    });
  }

  onEventoNivelOscilanteChange(): void {
    if (this.revertendoCheckbox) {
      this.revertendoCheckbox = false;
      return;
    }

    if (!this.direitoEditar || this.configuracaoGeralId == null) {
      return;
    }

    this.salvandoConfiguracaoGeral = true;
    this._configuracaoGeralService.update(
      { evento_niveloscilante: this.eventoNivelOscilanteDesativado },
      this.configuracaoGeralId,
    ).subscribe({
      next: () => {
        this.salvandoConfiguracaoGeral = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Configuração salva com sucesso.',
        });
      },
      error: () => {
        this.salvandoConfiguracaoGeral = false;
        this.revertendoCheckbox = true;
        this.eventoNivelOscilanteDesativado = !this.eventoNivelOscilanteDesativado;
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Não foi possível salvar a configuração.',
        });
      },
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.calculateScrollHeight();
    }, 200);
  }

  calculateScrollHeight(): void {
    if (this.tableWrapper && this.tableWrapper.nativeElement) {
      const wrapperHeight = this.tableWrapper.nativeElement.offsetHeight;
      const calculatedHeight = wrapperHeight - 120;
      this.scrollHeight = `${Math.max(calculatedHeight, 300)}px`;
    }
  }

  index(){
    this._awsRulesService.index().subscribe(json => {
      json.map(item => {
        if (item.ScheduleExpression.startsWith("cron(")) {
          const cronParts = item.ScheduleExpression.replace("cron(", "").replace(")", "").trim().split(" ");
          const minutos = cronParts[0]; 
          let horas = parseInt(cronParts[1], 10) - 4; 
      
          if (horas < 0) {
            horas = 24 + horas; 
          }
      
          item.time = `Toda às ${horas.toString().padStart(2, '0')}:${minutos.padStart(2, '0')} Horas`;
        } else if (item.ScheduleExpression.startsWith("rate(")) {
         
          const rateParts = item.ScheduleExpression.replace("rate(", "").replace(")", "").trim();
      
          if (rateParts.includes("minutes")) {
            const minutos = parseInt(rateParts.split(" ")[0], 10);
            item.time = `Intervalo de ${minutos} minutos`;
          } else if (rateParts.includes("hours")) {
            const horas = parseInt(rateParts.split(" ")[0], 10); 
            item.time = `Intervalo de ${horas} horas`;
          }
        }
        
       
      })
      this.data = json || [];
      setTimeout(() => {
        this.calculateScrollHeight();
      }, 200);
    })
  }

  openNew(){
    this.form.reset()
    this.displayModal = true
  }

  edit(event){
    this.form.reset()
    this.form.get('rule_name').setValue(event.Name)
    this.form.get('rule_description').setValue(event.Description)
    if (event.ScheduleExpression.startsWith("cron(")) {
      this.cron = true
    } else {
      this.cron = false
    }
    this.displayModal = true
    // this._awsRulesService.show(event.id).subscribe(json => {
    //   this.form.patchValue(json)
    //   this.displayModal = true
    // })
  }


  save(){
    this.loading = true
    let form = this.form.value
    let params = this.form.value
    
    if(this.cron == true){
     form.schedule_expression = 'cron('+form.schedule_expression+' '+(form.schedule_expression_cron + 4) % 24 + ' * * ? *)'
     
    //  form.schedule_expression = 'cron('+form.schedule_expression+' '+form.schedule_expression_cron+ ' * * ? *)'
    } else {
       form.schedule_expression = 'rate('+form.schedule_expression+' minutes)'
    }


    this._awsRulesService.save(params, params.id).subscribe(json => {
      this.loading = false
      this.index()
      this.displayModal = false
    }, err => {
      this.loading = false
    })

  }
}
